import Vue from 'vue'
import { moment } from '@/utils'
import VueMoment from 'vue-moment'

Vue.use(VueMoment, { moment })
